import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { Subscription } from 'rxjs';

import {
  NavigationService,
  PageTitleService,
} from '@tablesready/common-ui';
import { AppIcon, AppIconSize } from '@tablesready/frontend-icons';
import { HeaderTitleService } from '@tablesready/frontend-header';
import { FrontendBreakpointsService } from '@tablesready/frontend-breakpoints';

const URLS_FOR_ABSOLUTE_MENU = ['settings/preferences/resources', '/settings/preferences/party-fields'];

@Component({
  selector: 'tablesready-root',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit, OnDestroy {
  @ViewChild('alertSection') alertSection?: ElementRef;
  @ViewChild('mobileMenu') mobileMenu?: ElementRef;
  isSidebarVisible = false;
  isSidebarAbsolute = true;
  icon = AppIcon;
  iconSize = AppIconSize;
  isDesktop = true;

  private readonly subscription = new Subscription();

  constructor(
    private readonly pageTitleService: PageTitleService,
    private readonly breakpointService: FrontendBreakpointsService,
    private readonly headerService: HeaderTitleService,
    private readonly navService: NavigationService,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.detectMenuPosition();
  }

  ngOnInit(): void {
    this.pageTitleService.setTitle('Settings');
    this.headerService.setDataForRoute('settings', { title: 'Settings' });

    const desktopSub = this.breakpointService.observeSettingsDesktopMode()
      .subscribe((isDesktop) => {
        this.isDesktop = isDesktop;
      });
    this.subscription.add(desktopSub);

    const navSub = this.navService.navEvents$.subscribe((end) => {
      if (URLS_FOR_ABSOLUTE_MENU.includes(end?.url)) {
        this.isSidebarVisible = false;
      }

      this.detectMenuPosition();
    });
    this.subscription.add(navSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private detectMenuPosition(): void {
    this.isSidebarVisible = false;
    this.isSidebarAbsolute = window.innerWidth <= 1400 && URLS_FOR_ABSOLUTE_MENU.includes(this.navService.currentUrl);
  }
}
